/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Not_FoundInputs */

const es_co2_error_not_found = /** @type {(inputs: Error_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No encontramos lo que buscabas.`)
};

/**

* @param {Error_Not_FoundInputs} inputs
* @param {{ locale?: "es-CO" }} options
* @returns {LocalizedString}
*/
export const error_not_found = /** @type {((inputs?: Error_Not_FoundInputs, options?: { locale?: "es-CO" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Not_FoundInputs, { locale?: "es-CO" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return es_co2_error_not_found(inputs)
});